import React, { createContext, useState, useEffect } from "react";

// Internal
import Utils from "sccUtils";

export const LdapContext = createContext();

export default function LdapContextProvider(props) {
  const [ldapTakUsers, setLdapTakUsers] = useState(null);
  const [isLdapLoggedIn, setIsLdapLoggedIn] = useState(false);
  const [isLdapSyncing, setIsLdapSyncing] = useState(false);

  let takUidUrl = "/api/ldap/users";

  //   if (process.env.REACT_APP_IS_INDEPENDENT_DEV) {
  //     loginUrl = "http://localhost:5000" + loginUrl;
  //     logoutUrl = "http://localhost:5000" + logoutUrl;
  //   }

  const getLdapTakUsers = () => {
    // const dummyTakUsers = [
    //   {
    //     dn: "uid=jdoe,ou=users,dc=stagingad,dc=scctitan,dc=com",
    //     cn: "John Doe",
    //     sn: "",
    //     uid: "",
    //     recordType: 1,
    //   },
    //   {
    //     dn: "uid=kclark,ou=users,dc=stagingad,dc=scctitan,dc=com",
    //     cn: "Kara Clark",
    //     sn: "",
    //     uid: "",
    //     recordType: 1,
    //   },
    //   {
    //     dn: "uid=3div_admin,ou=TAK,ou=users,dc=stagingad,dc=scctitan,dc=com",
    //     cn: "tak_user",
    //     sn: "",
    //     uid: "",
    //     recordType: 1,
    //   },
    //   {
    //     dn: "uid=nortac_user,ou=TAK,ou=users,dc=stagingad,dc=scctitan,dc=com",
    //     cn: "tak_user",
    //     sn: "",
    //     uid: "",
    //     recordType: 1,
    //   },
    //   {
    //     dn: "uid=jdoe,ou=users,dc=stagingad,dc=scctitan,dc=com",
    //     cn: "John Doe",
    //     sn: "",
    //     uid: "",
    //     recordType: 1,
    //   },
    //   {
    //     dn: "uid=asmith,ou=users,dc=stagingad,dc=scctitan,dc=com",
    //     cn: "Alice Smith",
    //     sn: "",
    //     uid: "",
    //     recordType: 1,
    //   },
    //   {
    //     dn: "uid=3div_admin,ou=TAK,ou=users,dc=stagingad,dc=scctitan,dc=com",
    //     cn: "tak_user",
    //     sn: "",
    //     uid: "",
    //     recordType: 1,
    //   },
    // ];

    // setLdapTakUsers(dummyTakUsers);

    const ldName = Utils.getCookie("ldName");
    return fetch(takUidUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ldap_user: ldName,
      }),
    })
      .then((res) => res.json())
      .then(async (data) => {
        console.log("ldap tak users data", data);
        if (data && data.length) {
          setLdapTakUsers(data);
          return data;
        }
        return null;
      })
      .catch((err) => {
        console.log("err", err);

        return;
      });
  };

  const ldapSync = async () => {
    console.log("syncing ldap clicked");
    const ldName = Utils.getCookie("ldName");
    setIsLdapSyncing(true);
    return fetch("/api/ldap/sync", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ldap_user: ldName,
      }),
    })
      .then((res) => res.json())
      .then(async (data) => {
        console.log("ldap sync data", data);

        setIsLdapSyncing(false);

        return true;
      })
      .catch((err) => {
        console.log("err", err);

        setIsLdapSyncing(false);

        return false;
      });
  };

  useEffect(() => {
    console.log("isLdapLoggedIn changed", isLdapLoggedIn);
    if (isLdapLoggedIn) {
      getLdapTakUsers();
    } else {
      setLdapTakUsers(null);
    }
  }, [isLdapLoggedIn]);

  return (
    <LdapContext.Provider
      value={{
        ldapTakUsers,
        isLdapLoggedIn,
        getLdapTakUsers,
        setIsLdapLoggedIn,
        ldapSync,
        isLdapSyncing
      }}
    >
      {props.children}
    </LdapContext.Provider>
  );
}
